import { WebCallService } from "@/utilities/services/WebCallService";
import { PathHelper } from "@/utilities/helpers/PathHelper";
import { HttpType } from "@/utilities/enums/Enums";

export class WebhookService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;

    constructor() {
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
    }

    // --- Subscriptions ---

    public async getAllSubscriptions(): Promise<any> {
        const uri = this.uriHelper.webhook.getSubscriptionsPath();
        return await this.webCaller.HttpSend(HttpType.get, uri);
    }

    public async getSubscriptionById(id: number): Promise<any> {
        const uri = this.uriHelper.webhook.getSubscriptionByIdPath(id);
        return await this.webCaller.HttpSend(HttpType.get, uri);
    }

    public async createSubscription(dto: any): Promise<any> {
        const uri = this.uriHelper.webhook.createSubscriptionPath();
        return await this.webCaller.HttpSend(HttpType.post, uri, dto);
    }

    public async updateSubscription(id: number, dto: any): Promise<any> {
        const uri = this.uriHelper.webhook.updateSubscriptionPath(id);
        return await this.webCaller.HttpSend(HttpType.put, uri, dto);
    }

    public async deleteSubscription(id: number): Promise<any> {
        const uri = this.uriHelper.webhook.deleteSubscriptionPath(id);
        return await this.webCaller.HttpSend(HttpType.delete, uri);
    }

    // --- Subscriber ---

    public async getSubscriber(): Promise<any> {
        const uri = this.uriHelper.webhook.getSubscriberPath();
        return await this.webCaller.HttpSend(HttpType.get, uri);
    }

    public async updateSubscriber(dto: any): Promise<any> {
        const uri = this.uriHelper.webhook.updateSubscriberPath();
        return await this.webCaller.HttpSend(HttpType.put, uri, dto);
    }
    public async createSubscriber(dto: any): Promise<any> {
        const uri = this.uriHelper.webhook.createSubscriberPath();
        return await this.webCaller.HttpSend(HttpType.post, uri, dto);
    }
    public async getIdentifier(): Promise<any> {
        const uri = this.uriHelper.webhook.getIdentifier();
        return await this.webCaller.HttpSend(HttpType.get, uri);
    }
    public async failedAnAbDelivery(): Promise<any> {
        const uri = this.uriHelper.webhook.failedAnAbDelivery();
        return await this.webCaller.HttpSend(HttpType.get, uri);
    }
    public async sendFailedAnAbDelivery(dto: any): Promise<any> {
        const uri = this.uriHelper.webhook.sendFailedAnAbDelivery();
        return await this.webCaller.HttpSend(HttpType.post, uri,dto);
    }
}
